import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=056fd740&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitch.vue?vue&type=style&index=0&id=056fd740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fd740",
  null
  
)

export default component.exports